import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const key = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
export const thisMonthKey = () => key(new Date());
const options = () => {
  const now = new Date();
  return Array.from({ length: 15 }, (_, i) => new Date(now.getFullYear(), now.getMonth() - 2 + i, 1))
    .map((d) => ({ v: key(d), l: d.toLocaleDateString("en-AU", { month: "long", year: "numeric" }) }));
};

export const MonthPicker = ({ value, onChange, testid = "import-month" }) => (
  <div>
    <label className="text-[10px] text-[#9FA1A4] mb-1 block font-mono-data uppercase tracking-wide">Month for merge tags</label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testid} className="bg-[#F6F6FD] border-[#EEEFEF] h-9 w-56"><SelectValue /></SelectTrigger>
      <SelectContent className="bg-white border-[#EEEFEF] max-h-64">
        {options().map((o) => <SelectItem key={o.v} value={o.v}>{o.l}{o.v === thisMonthKey() ? " · this month" : ""}</SelectItem>)}
      </SelectContent>
    </Select>
    <p className="text-[11px] text-[#595D62] mt-1">{"{CURRENTMONTH}"} becomes this month; {"{NEXTMONTH}"} and {"{LASTMONTH}"} follow on. Due dates don't change.</p>
  </div>
);
